import React from 'react';
import { Text } from '@lana-ui/common';
import { Button } from '@lana-ui/login';
import PropTypes from 'prop-types';

const propTypes = {
    /**
     * Titulo de la página
     */
    title: PropTypes.string,
    /**
     * Texto secundario
     */
    subtitle: PropTypes.string,
    /**
     * Acción a realizar cuando se presiona el botón
     */
    onClick: PropTypes.string,
};

const Header = ({ title, subtitle, buttonIcon, titleBold, onClick }) => {
    return (
        <div className="drawer-accordion">
            <div className="drawer-accordion-text">
                {title && (
                    <Text
                        className={
                            titleBold
                                ? '--arial accordion-title --font-bold'
                                : '--arial accordion-title'
                        }
                        size="5xs"
                    >
                        {title}
                    </Text>
                )}

                {subtitle && (
                    <Text
                        className="--arial --font-bold accordion-subtitle"
                        size="2xs"
                    >
                        {subtitle}
                    </Text>
                )}
            </div>

            <div className="drawer-accordion-button">
                <Button
                    type="button"
                    icon={buttonIcon}
                    iconSize="m"
                    iconOnly
                    onClick={onClick}
                />
            </div>
        </div>
    );
};

Header.propTypes = Header;

export default Header;
